/**
 * The school app self-hosts Inter and Roboto through `next/font`. The admin
 * panel has no font pipeline, so the dashboard falls back to the CSS variables
 * below — `theme.module.scss` reads `--ho-font-inter` / `--ho-font-roboto`, and
 * pointing them at system stacks keeps every rule working unchanged.
 *
 * `hoFontVariables` stays exported (and empty) so the container's className
 * list is identical to the school app's.
 */
export const hoFontVariables = "";

/**
 * Applied on the dashboard container so every `var(--…-font-…)` in the ported
 * stylesheets resolves. Poppins, Inter and Roboto are already pulled in by the
 * Google Fonts import at the top of `src/index.css`.
 */
export const hoFontStyle: React.CSSProperties = {
  ["--font-poppins" as any]:
    "'Poppins', system-ui, -apple-system, 'Segoe UI', arial, sans-serif",
  ["--ho-font-inter" as any]:
    "'Inter', system-ui, -apple-system, 'Segoe UI', arial, sans-serif",
  ["--ho-font-roboto" as any]:
    "'Roboto', system-ui, -apple-system, 'Segoe UI', arial, sans-serif",
};

/**
 * Chart.js takes a font family string rather than a CSS variable, so the chart
 * widgets read it off this object. It mirrors the shape `next/font` returns in
 * the school app (`robotoFont.style.fontFamily`), which keeps those widgets
 * byte-identical to their originals.
 */
export const robotoFont = {
  style: {
    fontFamily: "'Roboto', system-ui, -apple-system, 'Segoe UI', arial, sans-serif",
  },
};
